import React, { useState, useEffect } from "react";
import Home from "../../Home";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { fetchOrganizationDetails } from "../actions";
import { Modal, Spinner } from "react-bootstrap";
import OrganizationTitle from "./OrganizationTitle";
import Breadcrumb from "../../../components/Breadcrumb";
import OrganizationRedirect from "./OrganizationRedirect";
import OrganizationInfo from "./OrganizationInfo";
import AffiliatedPersonnel from "./AffiliatedPersonnel";
import ChildFacilities from "./ChildFacilities";
import ParentFacilities from "./ParentFacilities";
import AllocatedEmployees from "./AllocatedEmployees";
import HospitalFunctions from "./HospitalFunctions";
import PrefectureFunctions from "./PrefectureFunctions";
import NursingInfo from "./NursingInfo";
import Maintenance from "../../Maintenance";

function OrganizationParent(props) {
  const navigate = useNavigate();
  let location = useLocation();
  const [lang] = useTranslation("language");
  const [isOpen, setIsOpen] = useState(false);
  const [id, setId] = useState("");
  const [loading, setLoading] = useState(true);
  const [maintenance, setMaintenance] = useState(false);
  const [isChange, setIsChange] = useState();
  const [isDelete, setIsDelete] = useState();
  const [parentFlag, setParentFlag] = useState();
  const [childFlag, setChildFlag] = useState();
  const [customerNotFound, setCustomerNotFound] = useState();
  const [data, setData] = useState({});
  const [orgData, setOrgData] = useState({});
  const [hospitalFunctionDetails, setHospitalFunctionDetails] = useState({});
  const [prefectureFunctionDetails, setPrefectureFunctionDetails] = useState(
    {}
  );
  const [nursingInfoDetails, setNursingInfoDetails] = useState({});
  const [activeTab, setActiveTab] = useState("organizationInfo");
  const [medicalSpecialityData, setMedicalSpecialityData] = useState([]);
  const routes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("Menu.organizationCustomer")}`,
      path: "/organizationCustomer",
    },
    {
      name: `${lang("organizationDetails.organizationCustomerDetails")}`,
      path: "",
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      window.scrollTo(0, 0);
      document.body.classList.remove("sidebar-open");
      document.body.classList.add("sidebar-close-tablet");
      setLoading(true);
      let id;
      let url = window.location.href;
      id = unescape(url).split("?orgId=")[1];
      setId(id);
      
      if (!id) return;
      
      try {
        const res = await fetchOrganizationDetails(id);
        if (res && res.data.success === true && res.data.data) {
          setIsChange(res.data.canRequestAttributeChange);
          setIsDelete(res.data.canRequestDelete);
          setOrgData(res && res.data && res.data.data);
          setData(
            res &&
            res.data &&
            res.data.data &&
            res.data.data.organizationInfo &&
            res.data.data.organizationInfo[0] &&
            res.data.data.organizationInfo[0]
          );
          setHospitalFunctionDetails(
            res &&
              res.data &&
              res.data.data.hospitalFunction &&
              res.data.data.hospitalFunction[0]
              ? res.data.data.hospitalFunction[0]
              : {}
          );
          setPrefectureFunctionDetails(
            res &&
              res.data &&
              res.data.data.prefectureFunction &&
              res.data.data.prefectureFunction[0]
              ? res.data.data.prefectureFunction[0]
              : {}
          );
          setNursingInfoDetails(
            res &&
              res.data &&
              res.data.data &&
              res.data.data.nurshingInfo &&
              res.data.data.nurshingInfo[0]
              ? res.data.data.nurshingInfo[0]
              : {}
          );
          setMedicalSpecialityData(
            res && res.data && res.data.data && res.data.data.orgSpeciality
          );
          setParentFlag(
            res && res.data && res.data.data && res.data.data.parentFlag
          );
          setChildFlag(
            res && res.data && res.data.data && res.data.data.childFlag
          );
          setLoading(false);
        } else if (
          res.data.success === false &&
          res.data.data.message === "given Request id not found"
        ) {
          setCustomerNotFound(true);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching organization details:", error);
        setLoading(false);
        setCustomerNotFound(true);
      }
    };
    
    fetchData();
  }, [location.search]);

  /*** 
  @purpose : Handle sidebar
  @Parameter : {}
  **/
  const orgSidebar = () => {
    setIsOpen(!isOpen);
    isOpen
      ? document.body.classList.remove("orgsidebar-collapse")
      : document.body.classList.add("orgsidebar-collapse");
  };

  /*** 
  @purpose : Change route
  @Parameter : {e, page}
  **/
  const changeRoute = (e, page) => {
    e.stopPropagation();
    navigate(page);
  };

  return (
    <Home>
      <Breadcrumb routes={routes} />
      {!loading && (
        <>
          <OrganizationRedirect
            id={data && data.orgCustID}
            isChange={isChange}
            isDelete={isDelete}
          />
          <div className="org-main">
            <div className="org-sidebar">
              <div className="org-top">
                <div className="org-id">
                  {/* data && data.legacyUnifiedCustomerCode   /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                  {data && data.unifiedCustomerCode            /* SAKAMOTO: AHDD-5861 Ultmarc code change */}
                </div>
                <div className="org-toggle" onClick={orgSidebar}>
                  <em className="bx bx-chevron-left"></em>
                </div>
              </div>
              <ul>
                <li>
                  <a
                    className={activeTab === "organizationInfo" ? "active" : ""}
                    onClick={() => {
                      setActiveTab("organizationInfo");
                    }}
                  >
                    <span className="org-icon">
                      <img src="images/org1.svg" alt="Menu" />
                    </span>
                    <span className="item-name">
                      {lang("OrganizationMenu.organizationInfo")}
                    </span>
                  </a>
                </li>
                <li>
                  <a
                    className={
                      activeTab === "affiliatedPersonnel" ? "active" : ""
                    }
                    onClick={() => {
                      setActiveTab("affiliatedPersonnel");
                    }}
                  >
                    <span className="org-icon">
                      <img src="images/org2.svg" alt="Menu" />
                    </span>
                    <span className="item-name">
                      {lang("OrganizationMenu.affiliatedPersonnel")}
                    </span>
                  </a>
                </li>
                {childFlag === true && (
                  <li>
                    <a
                      className={
                        activeTab === "childFacilities" ? "active" : ""
                      }
                      onClick={() => {
                        setActiveTab("childFacilities");
                      }}
                    >
                      <span className="org-icon">
                        <img src="images/org3.svg" alt="Menu" />
                      </span>
                      <span className="item-name">
                        {lang("OrganizationMenu.childFacilities")}
                      </span>
                    </a>
                  </li>
                )}
                {parentFlag === true && (
                  <li>
                    <a
                      className={
                        activeTab === "parentFacilities" ? "active" : ""
                      }
                      onClick={() => {
                        setActiveTab("parentFacilities");
                      }}
                    >
                      <span className="org-icon">
                        <img src="images/org4.svg" alt="Menu" />
                      </span>
                      <span className="item-name">
                        {lang("OrganizationMenu.parentFacilities")}
                      </span>
                    </a>
                  </li>
                )}
                <li>
                  <a
                    className={
                      activeTab === "allocatedEmployees" ? "active" : ""
                    }
                    onClick={() => {
                      setActiveTab("allocatedEmployees");
                    }}
                  >
                    <span className="org-icon">
                      <img src="images/org5.svg" alt="Menu" />
                    </span>
                    <span className="item-name">
                      {lang("OrganizationMenu.allocatedEmployees")}
                    </span>
                  </a>
                </li>
                {data && data.ultmarcRecordId === "00" && (
                  <>
                    <li>
                      <a
                        className={
                          activeTab === "hospitalFunctions" ? "active" : ""
                        }
                        onClick={() => {
                          setActiveTab("hospitalFunctions");
                        }}
                      >
                        <span className="org-icon">
                          <img src="images/org6.svg" alt="Menu" />
                        </span>
                        <span className="item-name">
                          {lang("OrganizationMenu.hospitalFunctions")}
                        </span>
                      </a>
                    </li>
                    <li>
                      <a
                        className={
                          activeTab === "prefectureFunctions" ? "active" : ""
                        }
                        onClick={() => {
                          setActiveTab("prefectureFunctions");
                        }}
                      >
                        <span className="org-icon">
                          <img src="images/org7.svg" alt="Menu" />
                        </span>
                        <span className="item-name">
                          {lang("OrganizationMenu.prefectureFunctions")}
                        </span>
                      </a>
                    </li>
                  </>
                )}
                <li>
                  <a
                    className={activeTab === "nursingInfo" ? "active" : ""}
                    onClick={() => {
                      setActiveTab("nursingInfo");
                    }}
                  >
                    <span className="org-icon">
                      <img src="images/org8.svg" alt="Menu" />
                    </span>
                    <span className="item-name">
                      {lang("OrganizationMenu.nursingInfo")}
                    </span>
                  </a>
                </li>
              </ul>
            </div>
            <div className="org-wrapper">
              <OrganizationTitle data={data} />
              {activeTab === "organizationInfo" && (
                <OrganizationInfo data={data} medical={medicalSpecialityData} />
              )}
              {activeTab === "affiliatedPersonnel" && (
                <AffiliatedPersonnel id={id} />
              )}
              {activeTab === "childFacilities" && <ChildFacilities id={id} />}
              {activeTab === "parentFacilities" && <ParentFacilities id={id} />}
              {activeTab === "allocatedEmployees" && (
                <AllocatedEmployees id={id} />
              )}
              {activeTab === "hospitalFunctions" && (
                <HospitalFunctions details={hospitalFunctionDetails} />
              )}
              {activeTab === "prefectureFunctions" && (
                <PrefectureFunctions
                  details={prefectureFunctionDetails}
                  typeOne={orgData.medicalFunctionType1}
                  typeTwo={orgData.medicalFunctionType2}
                  typeThree={orgData.medicalFunctionType3}
                  typeFour={orgData.medicalFunctionType4}
                />
              )}
              {activeTab === "nursingInfo" && (
                <NursingInfo details={nursingInfoDetails} />
              )}
            </div>
          </div>
        </>
      )}
      {loading && <Spinner animation="border" />}
      <Modal
        size="md"
        className="withdraw-modal"
        show={customerNotFound}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="warning-msg">
            <img src="images/warning2.svg" alt="Warning" />
            {lang("errorMessages.CUSTOMER_NOT_FOUND")}
          </div>
          <p className="mb-3">
            {lang("errorMessages.SEARCH_REQUESTS")}
            <a
              className="link"
              onClick={(e) => {
                changeRoute(e, "/organizationCustomer");
              }}
            >
              {lang("Menu.organizationCustomer")}
            </a>
          </p>
        </Modal.Body>
      </Modal>
    </Home>
  );
}

const mapStateToProps = (state) => {
  return {
    details: state.organizationCustomer.orgDetails,
  };
};

export default OrganizationParent;
